import { LICENSES_PATHS } from './constants';

export const fetchUrl = async (path: string) => {
  const response = await fetch(path);
  return await response.json();
};

export const getLicensePath = (path: string, context: any) => {
  return `${context.globalAEMContext.assetUri}/${LICENSES_PATHS.tenantId}${path}`;
};
